import React from 'react'
import styled from 'styled-components'
import { breakpoints, sizes, fonts, colors } from '../../css-variables'
import Accordion from '../Accordion'
import PromoCardD from '../../content-blocks/PromoCardD'
import { EmailIcon, FacebookIcon, InstagramIcon, TwitterIcon, WechatIcon, LinkedinIcon, WhatsAppIcon } from '../../../svg/social-icons'

const ChapterCard = ({ chapter }) => {

    return (
        <CardWrapper >
            <Accordion
                namespace={`accordion-chapters`}
                opentext={chapter?.title}
                closetext={chapter?.title}
                useAsNav
                >
                    <div className="social-icons-wrap">
                        {chapter?.chapterDetails?.csContactEmail && (<a href={`mailto:${chapter?.chapterDetails?.csContactEmail}`}><EmailIcon fillColor='#c5050c' /></a>)}
                        {chapter?.chapterDetails?.csFacebook && (<a href={chapter?.chapterDetails?.csFacebook}><FacebookIcon fillColor='#c5050c' /></a>)}
                        {chapter?.chapterDetails?.csTwitter && (<a href={`https://x.com/${chapter?.chapterDetails?.csTwitter}`}><TwitterIcon fillColor='#c5050c' /></a>)}
                        {chapter?.chapterDetails?.csInstagram && (<a href={`https://www.instagram.com/${chapter?.chapterDetails?.csInstagram}`}><InstagramIcon fillColor='#c5050c' /></a>)}
                        {chapter?.chapterDetails?.csWechat && (<a href={chapter?.chapterDetails?.csWechat}><WechatIcon fillColor='#c5050c' /></a>)}
                        {chapter?.chapterDetails?.csWhatsapp && (<a href={chapter?.chapterDetails?.csWhatsapp}><WhatsAppIcon fillColor='#c5050c' /></a>)}
                        {chapter?.chapterDetails?.csLinkedin && (<a href={chapter?.chapterDetails?.csLinkedin}><LinkedinIcon fillColor='#c5050c' /></a>)}
                    </div>
                    <div className="card-wrap">
                        <PromoCardD
                            key={`${chapter?.title}-upcoming-events`}
                            title={'Upcoming Events'}
                            url={`/events/all/?query=${encodeURI(chapter?.title)}`}
                            isNav
                            chapters
                        />
                        {chapter?.chapterDetails?.csShowLocalBadgerHangouts && (
                            <PromoCardD
                            key={`${chapter?.title}-badger-hangouts`}
                            title={'Local Badger Hangouts'}
                            url={'/game-watches'}
                            isNav
                            chapters
                            />
                        )}
                        {chapter?.chapterDetails?.csFundGuid && (
                            <PromoCardD
                            key={`${chapter?.title}-local-scholarship`}
                            title={'Give to Local Scholarship'}
                            url={`https://secure.supportuw.org/give/?id=${chapter?.chapterDetails?.csFundGuid}`}
                            isNav
                            chapters
                            />
                        )}
                    </div>
            </Accordion>
        </CardWrapper>
    )
}

const CardWrapper = styled.div`
    margin: 0;
    max-width: 716px;
    text-align: left;
    padding: 0 32px 0;
    @media screen and ${breakpoints.tabletL} {
        padding: 0;
    }
    .cardType {
        font-size: ${sizes.s14};
        line-height: ${sizes.s14};
        color: ${colors.categoryGrey};
        margin-bottom: ${sizes.s16};
        font-weight: 800;
        text-transform: uppercase;
    }
    .excerpt,
    .excerpt > * {
        font-size: ${sizes.s18};
        line-height: ${sizes.s26};
        a:link {
            color: ${colors.bgRed} !important;
            text-decoration: underline;
        }
    }
    a {
        cursor: pointer;
        p {
            margin: 0;
            color: ${colors.offBlack};
        }
        p:not(:last-child) {
            padding-bottom: 16px;
        }
        h3 {
            text-decoration: underline;
        }
    }
    a:hover,
    a:visited,
    a:active,
    a:link {
        color: #3c3c3c !important;
    }
    h3 {
        margin: 0;
        padding-bottom: 16px;
        color: ${colors.bgRed};
        font-weight: bold;
        font-style: italic;
        font-family: ${fonts.eaves};
        font-size: 24px;
        @media screen and ${breakpoints.tabletS} {
            font-size: 26px;
        }
    }
    &.topResult {
        border: 1px solid ${colors.cardBorder};
        margin-bottom: 32px;
        max-width: 760px;
        & > a > p,
        div {
            padding-left: 16px;
            padding-right: 16px;
            @media screen and ${breakpoints.tabletS} {
                padding-left: 32px;
                padding-right: 32px;
            }
        }
    }
    #accordion-chapters-inline-html{
        background-color: unset;
        border-top: 8px solid #f2f2f2;
        padding: 16px 0 0;
        .navWrap{
            margin: unset;
            .menuTitle{
                text-transform: capitalize;
            }
        }
        .card-wrap {
            display: flex; 
            gap: 24px; 
            justify-content: center;
            flex-direction: column;
            align-items: center;
            margin-bottom: 36px;
            .card-d{
                width: 100%;
                max-width: 320px;
                min-height: 68px;
            }
            @media screen and ${breakpoints.tabletL} {
                flex-direction: row;
                .card-d{
                    width: 256px;
                    max-width: 256px;
                    min-height: 124px;
                }
            }
        
        }
        .social-icons-wrap{
            margin: 0px 0px 16px;
            display: flex;
            justify-content: center;
            gap: 14px;
            svg{
                height: 24px;
            }
            svg:hover path{
                fill: #A5050A;
            }
        }   
    }

    &:last-of-type{
        #accordion-chapters-inline-html{
            border-bottom: 8px solid #f2f2f2;
        }
    }
`

export default ChapterCard
